import { FC } from "react";
import useMasonry from "@/hooks/useMasonry";
import MasonryList, { RenderMasonryItem } from "@/components/MasonryList";
import { FavoriteItemResponse } from "@/types/FavoriteItemResponse";
import ModalEntityListWrapper from "./ModalEntityListWrapper";
import { calculateOptimalListChildRatio } from "@/utils/calculateOptimalListChildRatio";

interface Props {
  data: FavoriteItemResponse[];
  onRender: RenderMasonryItem<FavoriteItemResponse>;
}

const FavoriteItemList: FC<Props> = ({ data, onRender }): JSX.Element => {
  const { items, numberOfColumns, containerRef, gap } =
    useMasonry<FavoriteItemResponse>(
      data,
      16,
      2,
      240,
      calculateOptimalListChildRatio, // リストアイテムを並べるにあたって最適な比率計算を適用
    );

  return (
    <ModalEntityListWrapper responses={data}>
      <MasonryList<FavoriteItemResponse>
        containerRef={containerRef}
        organizedItems={items}
        columnNumber={numberOfColumns}
        onRender={onRender}
        gap={gap}
      />
    </ModalEntityListWrapper>
  );
};

export default FavoriteItemList;
